import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import './menuNavegacao.css';

interface MenuAdminProps {
    logout: () => void;
}

const MenuAdmin: React.FC<MenuAdminProps> = ({ logout }) => {
    return (
        <>
            <Dropdown.Item as={Link} to="/milshop/usuario/meus-anuncios" className="custom-dropdown-item">
                Meus Anúncios
            </Dropdown.Item>  
            <Dropdown.Item as={Link} to="/milshop/usuario/meus-favoritos" className="custom-dropdown-item">
                Meus Favoritos
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item as={Link} to="/milshop/cidade/consultar" className="custom-dropdown-item">
                Consultar Cidade
            </Dropdown.Item>
            <Dropdown.Item as={Link} to="/milshop/usuario/consultar" className="custom-dropdown-item">
                Consultar Usuário
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item as="button" onClick={logout} className="custom-dropdown-item">
                Sair
            </Dropdown.Item>
        </>
    );
};

export default MenuAdmin;
